<template>
  <div class="breadcrumb">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- to为点击跳转 title为路由中的meta属性定义的标题 -->
      <el-breadcrumb-item v-for="(item, index) in breadList" :key="index" :to="item.path">
        {{ item.meta.breadcrumb }}
      </el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>

<script>
import { getCategoryList } from "@/api/common/common.js";

export default {
  name: "Breadcrumb",
  data() {
    return {
      breadList: [],
      menuList: [],
      categoryName: "",
      tabName: "",
    };
  },
  methods: {
    async getBreadcrumb() {
      //获取路由
      let categoryId = this.$route.query?.categoryId;
      let tabcode = this.$route.query?.tabcode;

      if (categoryId && tabcode) {
        let params = [categoryId, tabcode];

        await this.navList(params);

        this.menuList.forEach((item) => {
          this.linkType = item.linkType;

          if (item.categoryCode == categoryId) {
            this.categoryName = item.categoryName;
          }
          if (item.categoryCode == tabcode) {
            this.tabName = item.categoryName;
          }
        });

        let home = { path: "/", meta: { breadcrumb: "首页" } };
        let tab = {
          path:
            (this.linkType != "3" ? "/article" : "/cooperateUnit/list") +
            "?categoryId=" +
            categoryId +
            "&linkType=" +
            this.linkType +
            "&tabcode=" +
            tabcode,
          meta: { breadcrumb: this.tabName },
        };

        let category = { path: "", meta: { breadcrumb: this.categoryName } };

        this.breadList =
          categoryId == tabcode ? [home, tab] : [home, tab, category];
      } else {
        if (this.$route.path.indexOf("newsDetail")) {
          let home = { path: "/", meta: { breadcrumb: "首页" } };
          let detail = { path: "", meta: { breadcrumb: "信息详情" } };

          this.breadList = [home, detail];
        }
      }
    },
    navList(params) {
      return new Promise((resolve, reject) => {
        getCategoryList(params)
          .then((res) => {
            this.menuList = res.data;
            resolve(res.data);
          })
          .catch((err) => {
            reject(err.data);
          });
      });
    },
  },
  created() {
    //生命周期中调用获取数据的方法
    this.getBreadcrumb();
  },
  watch: {
    $route() {
      //监听$route
      this.getBreadcrumb();
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  color: #fff;
}
</style>